import { DayOfWeek } from 'office-ui-fabric-react/lib/utilities/dateValues/DateValues';

/**
 * Common constants and methods
 */
let TimeConstants = {
    MillisecondsInOneDay: 86400000,
    MillisecondsIn1Sec: 1000,
    MillisecondsIn1Min: 60000,
    MillisecondsIn30Mins: 1800000,
    MillisecondsIn1Hour: 3600000,
    MinutesInOneDay: 1440,
    MinutesInOneHour: 60,
    SecondsInOneMinute: 60,
    DaysInOneWeek: 7,
    AllDaysOfWeek: [
        DayOfWeek.Sunday,
        DayOfWeek.Monday,
        DayOfWeek.Tuesday,
        DayOfWeek.Wednesday,
        DayOfWeek.Thursday,
        DayOfWeek.Friday,
        DayOfWeek.Saturday,
    ],
};
export default TimeConstants;
